import { Injectable } from '@nestjs/common';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { WorkstationCategories } from './workstation-category.entity';
import { WorkstationCategoryAdapter } from './dto/workstation-category.adapter';
import { WorkstationCategoryDTO } from './dto/workstation-category.dto';
import { WorkstationCategoryResponseModel, AllWorkstationCategoryResponseModel } from '@gtpl/shared-models/production-management';
import { WorkstationCategoryRequest } from './dto/workstatin-category.request';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Injectable()
export class WorkstationCategoryService {
    constructor(
      private logService:LogsService,

        @InjectRepository(WorkstationCategories)
        private workstationCategoriesRepository: Repository<WorkstationCategories>,
        private workstationCategoriesAdapter: WorkstationCategoryAdapter,
      ) {}
    /**
     * 
     * @param workstationCategoryDTO 
     * @param isUpdate 
     * @param request 
     * @returns 
     */
      async createWorkstationCategory(workstationCategoryDTO: WorkstationCategoryDTO, isUpdate: boolean,request:Request): Promise<WorkstationCategoryResponseModel> {
        try {
            console.log(isUpdate);
            // to check whether Workstation Category exists with the passed name  or not. if isUpdate is false, a check will be done whether a record with the passed Workstation Category is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed Workstation Category  then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
            if (!isUpdate) {
                const WorkstationCategoryEntity = await this.getWorkstationCategoryDetailsWithoutRelations(workstationCategoryDTO.workstationCategory);
                if (WorkstationCategoryEntity) {
                    throw new WorkstationCategoryResponseModel(false,11104, 'Workstation Category already exists');         
                } 
            // var notificationStatus='Created';
            }else{
                const WorkstationCategoryEntity = await this.getWorkstationCategoryDetailsWithoutRelations(workstationCategoryDTO.workstationCategory);
                if(WorkstationCategoryEntity){
                    if(WorkstationCategoryEntity.workstationCategoryId!=workstationCategoryDTO.workstationCategoryId) {
                        throw new WorkstationCategoryResponseModel(false,11104, 'Workstation Category already exists');      
                    }
                }
            }

            // else{
            // var notificationStatus='Updated';
            // }
            const convertedWorkstationCategoryEntity: WorkstationCategories = this.workstationCategoriesAdapter.convertDtoToEntity(workstationCategoryDTO,isUpdate);
            const savedWorkstationCategoryEntity: WorkstationCategories = await this.workstationCategoriesRepository.save(
                convertedWorkstationCategoryEntity
            );
            const savedWorkstationCategoryDto: WorkstationCategoryDTO = this.workstationCategoriesAdapter.convertEntityToDto(savedWorkstationCategoryEntity);
            if (savedWorkstationCategoryDto) {
            // generating resposnse
            const response = new WorkstationCategoryResponseModel(true,isUpdate ? 11101 : 11100,isUpdate? 'Workstation Category Updated Successfully': 'Workstation Category Created Successfully',savedWorkstationCategoryDto);
            // const name=isUpdate?'updated':'created'
            // const newLogDto = new LogsDto(1,name, 'WorkstationCategories', savedWorkstationCategoryDto.workstationCategoryId, true, '',savedWorkstationCategoryDto.createdUser)
            // let res = await this.logService.createLog(newLogDto);
            // console.log(res);
            return response;
            } else {
            throw new WorkstationCategoryResponseModel(false,11106,'Workstation Category saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            throw error;
        }
    }
    async getWorkstationCategoryDetailsWithoutRelations(workstationCategory: string): Promise<WorkstationCategories> {
        // tslint:disable-next-line: typedef
        const workstationCategoryResponse = await this.workstationCategoriesRepository.findOne({
        where: {workstationCategory: Raw(alias => `workstation_category = '${workstationCategory}'`)},
        });
        if (workstationCategoryResponse) {
        return workstationCategoryResponse;
        } else {
        return null;
        }
    }
    /**
     * 
     * @returns AllWorkstationCategoryResponseModel
     */
    async getAllWorkstationCategories(): Promise<AllWorkstationCategoryResponseModel> {
        // const page: number = 1;
        try {
          const workstationCategoryDTO: WorkstationCategoryDTO[] = [];
          //retrieves all companies
          const workstationEntities: WorkstationCategories[] = await this.workstationCategoriesRepository.find({order :{'workstationCategory':'ASC'}});
          //console.log(workstationEntities);
          if (workstationEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            workstationEntities.forEach(workstationEntity => {
              const convertedstatesDto: WorkstationCategoryDTO = this.workstationCategoriesAdapter.convertEntityToDto(
                workstationEntity
              );
              workstationCategoryDTO.push(convertedstatesDto);
            });
            const response = new AllWorkstationCategoryResponseModel(true,11108,"Workstation Categories retrieved successfully",workstationCategoryDTO);
            // const newLogDto = new LogsDto(1,'view', 'WorkstationCategories', 0, true, '','')
            // let res = await this.logService.createLog(newLogDto);
            // console.log(res);
            return response;
          } else {
            throw new WorkstationCategoryResponseModel(false,99998, 'Data not found');
          }
        } catch (err) {
          throw err;
        }
      }
      /**
       * 
       * @param workstationCategoryReq 
       * @returns 
       */
      async activateorDeactivateWorkstationCategory(workstationCategoryReq: WorkstationCategoryRequest): Promise<WorkstationCategoryResponseModel> {
        try {
            const workstationCategoryExists = await this.getWorkstationCategoryById(workstationCategoryReq.workstationCategoryId);
            if (workstationCategoryExists) {
                if (workstationCategoryReq.versionFlag !== workstationCategoryExists.versionFlag) {
                    throw new WorkstationCategoryResponseModel(false,10113, 'Someone updated the current Workstation Category information.Refresh and try again');
                } else {
                    const workstationCategoryStatus =  await this.workstationCategoriesRepository.update(
                        { workstationCategoryId: workstationCategoryReq.workstationCategoryId },
                        { isActive: workstationCategoryReq.isActive,updatedUser: workstationCategoryReq.updatedUser });
                    
                    if (workstationCategoryExists.isActive) {
                        if (workstationCategoryStatus.affected) {
                            const workstationCategoryResponse: WorkstationCategoryResponseModel = new WorkstationCategoryResponseModel(true, 10115, 'Workstation Category is de-activated successfully');
                            return workstationCategoryResponse;
                        } else {
                            throw new WorkstationCategoryResponseModel(false,10111, 'Workstation Category is already deactivated');
                        }
                    } else {
                        if (workstationCategoryStatus.affected) {
                            const workstationCategoryResponse: WorkstationCategoryResponseModel = new WorkstationCategoryResponseModel(true, 10114, 'Workstation Category is activated successfully');
                            return workstationCategoryResponse;
                        } else {
                            throw new WorkstationCategoryResponseModel(false,10112, 'Workstation Category is already activated');
                        }
                    }
                }
            } else {
                throw new WorkstationCategoryResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
    /**
     * 
     * @param workstationCategoryId 
     * @returns if workstation category exists
     */
    async getWorkstationCategoryById(workstationCategoryId: number): Promise<WorkstationCategories> {
        const Response = await this.workstationCategoriesRepository.findOne({
        where: {workstationCategoryId: workstationCategoryId},
        });
        if (Response) {
        return Response;
        } else {
        return null;
        }

        
    }

    async getAllActiveWorkstationCategories(): Promise<AllWorkstationCategoryResponseModel> {
        // const page: number = 1;
        try {
          const workstationCategoryDTO: WorkstationCategoryDTO[] = [];
          //retrieves all companies
          const workstationEntities: WorkstationCategories[] = await this.workstationCategoriesRepository.find({order :{'workstationCategory':'ASC'} ,where:{isActive:true}});
          //console.log(workstationEntities);
          if (workstationEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            workstationEntities.forEach(workstationEntity => {
              const convertedstatesDto: WorkstationCategoryDTO = this.workstationCategoriesAdapter.convertEntityToDto(
                workstationEntity
              );
              workstationCategoryDTO.push(convertedstatesDto);
            });
            const response = new AllWorkstationCategoryResponseModel(true,11108,"Workstation Categories retrieved successfully",workstationCategoryDTO);
            return response;
          } else {
            throw new WorkstationCategoryResponseModel(false,99998, 'Data not found');
          }
        } catch (err) {
          throw err;
        }
      }
}
